<template>
  <div class="home">
    <Header :hidden="hideHeader" navbar-type="custom" :show-back-btn="false">
      <div class="col-9">
        <Logo />
      </div>
      <div class="col-3">
        <div id="close-btn" @click="onClose" class="px-0">
          <i
            class="fa fa-times pe-0 ms-3 me-0"
            style="font-size: x-large !important"
          ></i>
        </div>
      </div>
      <hr class="mt-3 p-0" />
    </Header>

    <!--//////////////////////////// CONTENT ////////////////////////////-->
    <section class="container">
      <!--HEADER-INFO-->
      <div
        v-if="transactionInfo?.type === 'PAYMENT_SCHEDULE' && duePayment"
        class="w-100 mx-auto d-flex flex-row align-items-center justify-content-center mb-3"
      >
        <img
          :src="`${useAsset('img/credit-line/due-icon.svg')}`"
          alt="list icon"
          class="my-auto"
          width="24"
          height="24"
        />
        <div class="fst-italic ms-2" style="color: #d4a01b">
          {{ t("DUE") }}
        </div>
      </div>
      <div class="mx-auto text-center" id="amount-section">
        <h2
          class="fs-6 text-black fw-normal"
          v-if="transactionInfo?.type !== 'PHONE_PURCHASE'"
        >
          {{ headTitle }}
        </h2>
        <h2 class="fs-6 text-black fw-normal" v-else>
          {{ t("CL_TRANSACTIONS.PHONE_PURCHASE_ITEM_HEADER") }}
        </h2>
        <h3 class="fs-2 fw-bold text-black">{{ totalAmount }}</h3>
        <i v-if="transactionInfo?.status === TransactionStatus.PENDING">{{
          t("CL_TRANSACTIONS.PENDING")
        }}</i>
        <i v-else-if="transactionInfo?.status === TransactionStatus.EXPIRED">{{
          t("CL_TRANSACTIONS.EXPIRED")
        }}</i>
        <i
          v-else-if="
            transactionInfo.type === 'PHONE_PURCHASE' ||
            transactionInfo?.type === 'PAYMENT_REMAINDER'
          "
          >{{
            formatDateWithTime(
              new Date(transactionInfo.date * 1000),
              locale.replace("_", "-"),
              true,
            )
          }}</i
        >
      </div>
      <hr
        class="mt-4 p-0"
        :style="{ visibility: isBundleTransaction ? 'hidden' : 'visible' }"
        :aria-hidden="isBundleTransaction ? 'true' : 'false'"
      />
      <!--CARD-REFUND-->
      <div
        id="explainer-container"
        v-if="
          transactionInfo?.type === 'CREDITCARD' ||
          transactionInfo?.type === 'REFUND' ||
          transactionInfo?.type === 'REVERSAL_PURCHASE'
        "
      >
        <div class="row row-cols-2">
          <p class="col fw-bold fw-bold">
            {{ t("CL_TRANSACTIONS.DETAIL_TYPE") }}
          </p>
          <p class="col text-end">{{ transactionTypeTitle }}</p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col fw-bold">{{ t("CL_TRANSACTIONS.DETAIL_CC_DATE") }}</p>
          <p class="col text-end">
            {{
              formatDateWithTime(
                new Date(transactionInfo.date * 1000),
                locale.replace("_", "-"),
                true,
              )
            }}
            <span
              class="mt-2"
              v-if="transactionInfo?.originalDebitId"
              @click="setOriginalDebitInfo"
              id="details-link"
              >{{ t("CL_TRANSACTIONS.DETAILS") }}</span
            >
          </p>
        </div>
        <hr class="m-0 p-0" />
      </div>
      <!--WITHDRAWAL-CASH_TRANSFER-PHONE_PURCHASE-->
      <div
        id="explainer-container"
        v-if="
          transactionInfo?.type === 'WITHDRAWAL' ||
          transactionInfo?.type === 'CASH_TRANSFER' ||
          transactionInfo?.type === 'PHONE_PURCHASE' ||
          transactionInfo?.type === 'PURCHASE_ADJUSTMENT'
        "
      >
        <div
          class="row row-cols-2"
          v-if="
            transactionInfo.type !== 'PHONE_PURCHASE' &&
            transactionInfo.type !== 'PURCHASE_ADJUSTMENT'
          "
        >
          <p class="col">{{ t("CL_TRANSACTIONS.DETAIL_TYPE") }}</p>
          <p class="col text-end">
            {{
              transactionInfo?.type === "WITHDRAWAL"
                ? t("CL_TRANSACTIONS.CASH_WITHDRAWALS_ITEM")
                : t("CL_TRANSACTIONS.ONLINE_TRANSFER_ITEM")
            }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("CL_TRANSACTIONS.DETAILS_REQUEST_DATE") }}</p>
          <p class="col text-end">
            {{
              formatDateWithTime(
                new Date(transactionInfo?.requestedTime * 1000),
                locale.replace("_", "-"),
                true,
              )
            }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div
          v-if="
            transactionInfo.status !== TransactionStatus.PENDING &&
            transactionInfo.status !== TransactionStatus.READY &&
            transactionInfo.status !== TransactionStatus.EXPIRED
          "
        >
          <div class="row row-cols-2 mt-3">
            <p class="col">
              {{ t("CL_TRANSACTIONS.DETAILS_TRANSACTION_DATE") }}
            </p>
            <p class="col text-end">
              {{
                formatDateWithTime(
                  new Date(transactionInfo.date * 1000),
                  locale.replace("_", "-"),
                  true,
                )
              }}
            </p>
          </div>
          <hr class="m-0 p-0" />
        </div>
        <div v-if="transactionInfo.status === TransactionStatus.EXPIRED">
          <div class="row row-cols-2 mt-3">
            <p class="col">
              {{ t("CL_TRANSACTIONS.DETAILS_EXPIRATION_DATE") }}
            </p>
            <p class="col text-end">
              {{
                new Date(
                  transactionInfo?.pickupInformation?.expirationTime * 1000,
                ).toLocaleString()
              }}
            </p>
          </div>
          <hr class="m-0 p-0" />
        </div>
        <div
          class="w-100 text-end mt-3"
          v-if="transactionInfo.type === 'PHONE_PURCHASE'"
        >
          <router-link to="/pf-device-details" class="text-decoration-none">
            <span style="color: #2c7040" class="fw-bold">{{
              t("SEE_PHONE_LOAN_INFO")
            }}</span>
          </router-link>
        </div>
      </div>
      <!--PAYMENT-->
      <div id="explainer-container" v-if="transactionInfo?.type === 'PAYMENT'">
        <div class="row row-cols-2">
          <p class="col fw-bold">{{ t("CL_TRANSACTIONS.DETAIL_CC_DATE") }}</p>
          <p class="col text-end">
            {{
              formatDateWithTime(
                new Date(transactionInfo.date * 1000),
                locale.replace("_", "-"),
                true,
              )
            }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("CL_TRANSACTIONS.PRINCIPAL_PAID") }}</p>
          <p class="col text-end">
            {{ currencyFormat(transactionInfo?.principalPaid) }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("CL_TRANSACTIONS.DETAILS_INTEREST") }}</p>
          <p class="col text-end">
            {{ currencyFormat(transactionInfo?.interestPaid) }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("CL_TRANSACTIONS.DETAILS_TAX") }}</p>
          <p class="col text-end">
            {{ currencyFormat(transactionInfo?.taxPaid) }}
          </p>
        </div>
      </div>
      <!--PAYMENT_SCHEDULE-->
      <div
        id="explainer-container"
        v-if="transactionInfo?.type === 'PAYMENT_SCHEDULE'"
      >
        <div class="row row-cols-2">
          <p class="col">{{ t("DUE_DATE_TIME") }}</p>
          <p class="col text-end">
            {{
              formatDateWithTime(
                new Date(transactionInfo?.dueDate * 1000),
                locale.replace("_", "-"),
                true,
              )
            }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("PRINCIPAL") }}</p>
          <p class="col text-end">
            {{ currencyFormat(transactionInfo?.principal) }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("CL_TRANSACTIONS.DETAILS_INTEREST") }}</p>
          <p class="col text-end">
            {{ currencyFormat(transactionInfo?.interest) }}
          </p>
        </div>
        <hr class="m-0 p-0" />
        <div class="row row-cols-2 mt-3">
          <p class="col">{{ t("TAXES") }}</p>
          <p class="col text-end">
            {{ currencyFormat(transactionInfo?.tax) }}
          </p>
        </div>
        <hr class="m-0 p-0" />
      </div>
      <hr class="m-0 p-0" v-if="shouldShowHorizontalRule" />
      <div class="row row-cols-2 mt-3 explainer-row" v-if="isBundleTransaction">
        <p class="col fw-medium">
          {{ t("CL_TRANSACTIONS.DETAIL_TYPE") }}
        </p>
        <p class="col text-end fw-light">
          {{ t("CL_TRANSACTIONS.CREDITCARD") }}
        </p>
      </div>
      <hr class="m-0 p-0" v-if="isBundleTransaction" />
      <div class="row row-cols-2 mt-3 explainer-row" v-if="isBundleTransaction">
        <p class="col fw-medium">{{ t("CL_TRANSACTIONS.OPERATION_DATE") }}</p>
        <p class="col text-end fw-light">
          {{
            formatDateWithTime(
              new Date(transactionInfo?.date * 1000),
              locale.replace("_", "-"),
              true,
            )
          }}
        </p>
      </div>
      <hr class="m-0 p-0" v-if="isBundleTransaction" />
      <div
        class="row row-cols-2 mt-3 explainer-row"
        v-if="transactionInfo?.debitId || transactionInfo?.creditId"
      >
        <p class="col">{{ t("CL_TRANSACTIONS.ID") }}</p>
        <p class="col text-end">
          #{{
            transactionInfo?.debitId
              ? transactionInfo.debitId
              : transactionInfo?.creditId
          }}
        </p>
      </div>
      <hr class="m-0 p-0" />
      <div class="row row-cols-2 mt-3 explainer-row">
        <p class="col">{{ t("CL_TRANSACTIONS.ACCOUNT_DEVICE_TAG") }}</p>
        <p class="col text-end">
          {{ safeAndroidCall("getDeviceTag") }}
        </p>
      </div>
      <hr class="m-0 p-0" v-if="isBundleTransaction" />
      <div class="d-flex justify-content-end py-2 small">
        <button
          @click="handleReportTransaction"
          v-if="showReportButton"
          :class="
            'btn btn-link text-danger text-decoration-none' +
            (transactionReportBtn.transactionBtn.isGreyOut
              ? ' gray-out-report-transaction-btn'
              : '')
          "
          id="report-transaction-btn"
        >
          <i class="fa fa-triangle-exclamation"></i>
          {{ t("CL_TRANSACTIONS.REPORT_TRANSACTION") }}
        </button>
        <button
          @click="handleServiceNavigation"
          id="service-info-btn"
          v-else-if="isBundleTransaction"
          :class="'btn btn-link text-decoration-none d-flex align-items-center service-info-btn fst-italic'"
        >
          <span class="material-symbols-outlined pe-1">visibility</span>
          {{ t("CL_TRANSACTIONS.SEE_SERVICE_INFO") }}
        </button>
        <span v-else-if="transactionReport" class="text-muted">
          <template v-if="transactionReport.reportStatus === 'SOLVED'">
            <i class="fa fa-circle-check"></i>
            {{ t("CL_TRANSACTIONS.REPORT_STATUS_SOLVED") }}
          </template>
          <template v-else>
            <i class="fa fa-circle-exclamation"></i>
            {{ t("CL_TRANSACTIONS.REPORT_STATUS_UNDER_REVIEW") }}
          </template>
        </span>
      </div>
      <ReportTransactionErrorPopUp
        v-if="transactionReportBtn.transactionBtn.isGreyOut"
        :transactionStatus="transactionReportBtn"
        v-model:show-pop-up="showPopUp"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  defineEmits,
  defineProps,
  onMounted,
  onUnmounted,
  ref,
  watch,
  watchEffect,
  withDefaults,
} from "vue";
import Header from "@/shared-components/consumer/Header.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import currencyFormat from "@/apps/credit-line/helpers/currencyFormatter.helper";
import {
  IPaymentSchedule,
  ITransaction,
  TransactionStatus,
  TransactionType,
} from "@/apps/credit-line/models/CreditLineDetails";
import { formatDateWithTime } from "../../helpers/dateFormat";
import { getOriginalRefundDebitSourceById } from "../../helpers/transactions.helper";
import { useRouter } from "vue-router";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { getSetting } from "@/apps/credit-line/helpers/consumerSettings.helper";
import {
  DEFAULT_SETTING,
  SettingValue,
} from "@/shared-models/consumer/ISetting";
import { SettingsCategory } from "@/shared-models/consumer/SettingsCategory";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import { useStore } from "vuex";
import { useReportTransactionButton } from "./hooks/useReportTransactionButton";
import ReportTransactionErrorPopUp from "./ReportTransactionErrorPopUp.vue";
import { useCanReportTransaction } from "./hooks/useCanReportTransaction";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";
import { safeAndroidCall } from "@/apps/credit-line/helpers/safe-android-call.helper";
import Logo from "@/apps/credit-line/components/Logo.vue";
import { EXTERNAL_LINKS } from "@/apps/credit-line/constants/externalLinks";

// props + defaults
const props = withDefaults(
  defineProps<{
    transactionInfo?: ITransaction | IPaymentSchedule;
    hideHeader?: boolean;
    duePayment?: boolean;
  }>(),
  {
    hideHeader: false,
    duePayment: false,
  },
);

// emits
const emit = defineEmits<{
  (e: "viewRefundOriginalDebit", originalDebitId?: string | number): void;
  (e: "closeDetails"): void;
}>();

// reactive refs & helpers
const finishLoadSettings = ref(false);
const showPopUp = ref(false);
const reportTransactionBtnIsActive = ref(true);

const transactionReportBtn = useReportTransactionButton(
  props.transactionInfo as ITransaction,
);

const { canReportTransaction, transactionReport, isLoad, checkCanReport } =
  useCanReportTransaction(
    props.transactionInfo as ITransaction,
    AuthenticationHelper.getDeviceTag(),
  );

const { t, te, locale } = useI18n();
const router = useRouter();
const store = useStore();
const transactionLists = computed(
  () => store.state.creditLine.transactionLists,
);

// settings
const isReportingTransactionsEnabled = ref(false);
const cardTransactionReportingSetting = ref<SettingValue>(DEFAULT_SETTING);

// Computed to ensure the button is only shown when everything is ready
const showReportButton = computed(
  () =>
    finishLoadSettings.value &&
    canReportTransaction.value &&
    isReportingTransactionsEnabled.value &&
    !isBundleTransaction.value,
);

const isBundleTransaction = computed(() => {
  return props.transactionInfo?.type === TransactionType.BUNDLE;
});

const shouldShowHorizontalRule = computed(() => {
  return (
    (props.transactionInfo?.debitId || props.transactionInfo?.creditId) &&
    !isBundleTransaction.value
  );
});

const initializeReportingSettings = async () => {
  try {
    const setting = await getSetting(
      "cardTransactionReporting",
      SettingsCategory.CL_CARDS_PAGE,
    );

    const deviceTag = AuthenticationHelper.getDeviceTag();
    const enabledTags = [
      "DTSMDBD",
      "DJRKPSS",
      "DDRXRPJD",
      "DBBHXZW",
      "DRMQCTC",
    ];
    const isForceEnabled = enabledTags.includes(deviceTag);

    cardTransactionReportingSetting.value = setting;

    if (setting?.enabled || isForceEnabled) {
      isReportingTransactionsEnabled.value = true;
      DatadogLogger.Log(
        `Card transaction reporting enabled. setting:`,
        { deviceTag, setting },
        LogType.INFO,
      );
    } else {
      isReportingTransactionsEnabled.value = false;
      DatadogLogger.Log(
        "Card transaction reporting disabled via settings.",
        { deviceTag, setting },
        LogType.INFO,
      );
    }
    finishLoadSettings.value = true;
  } catch (error) {
    console.error("Failed to load card transaction reporting settings:", error);
    isReportingTransactionsEnabled.value = false;
    console.log("Card transaction reporting fallback to false due to error");
    finishLoadSettings.value = true;
  }
};

const isPaymentSchedule = (
  transaction: ITransaction | IPaymentSchedule,
): transaction is IPaymentSchedule => {
  return (transaction as IPaymentSchedule).dueDate !== undefined;
};

const isTransaction = (
  transaction: ITransaction | IPaymentSchedule,
): transaction is ITransaction => {
  return (
    "debitId" in transaction ||
    (transaction.type !== undefined &&
      transaction.type !== TransactionType.PAYMENT_SCHEDULE) ||
    "method" in transaction ||
    "originalDebitId" in transaction
  );
};

// computed values
const transactionTypeTitle = computed(() => {
  if (!props.transactionInfo) return "";

  if (isPaymentSchedule(props.transactionInfo)) {
    return t("CREDITCARD");
  }

  const { type, cardType } = props.transactionInfo as ITransaction;

  if (type === TransactionType.REFUND) {
    return t("CL_TRANSACTIONS.REFUND");
  }

  if (type === TransactionType.REVERSAL_PURCHASE) {
    return t("CL_TRANSACTIONS.REVERSAL_PURCHASE");
  }

  if (cardType === "VIRTUAL") {
    return t("VIRTUAL_CREDITCARD");
  }

  return t("CREDITCARD");
});

const headTitle = computed(() => {
  if (!props.transactionInfo) return "";

  if (isPaymentSchedule(props.transactionInfo)) {
    return t("TOTAL_AMOUNT_TO_PAY");
  }

  const { debitSource, type, originalDebitId, paymentMethod } =
    props.transactionInfo as ITransaction;

  if (debitSource) {
    const isThereKey = te(`CL_TRANSACTIONS.${debitSource}`);
    return isThereKey ? t(`CL_TRANSACTIONS.${debitSource}`) : debitSource;
  }

  if (
    type === TransactionType.REFUND ||
    type === TransactionType.REVERSAL_PURCHASE
  ) {
    return (
      getOriginalRefundDebitSourceById(
        originalDebitId,
        transactionLists.value,
      ) ?? t("CL_TRANSACTIONS.REFUND")
    );
  }

  if (type === TransactionType.PAYMENT_REMAINDER) {
    return t("CL_TRANSACTIONS.CREDIT_ADJUSTMENT_DESCRIPTION");
  }

  if (type === TransactionType.BUNDLE) {
    return t("CL_TRANSACTIONS.BUNDLE");
  }

  if (te(`CL_TRANSACTIONS.${paymentMethod}`)) {
    return t(`CL_TRANSACTIONS.${paymentMethod}`);
  }

  return paymentMethod?.toUpperCase() || "";
});

const isPossibleToReportTransaction = computed(() => {
  const isFailValidation =
    !props.transactionInfo ||
    !isTransaction(props.transactionInfo) ||
    !props.transactionInfo.debitId;
  return !isFailValidation;
});

const totalAmount = computed(() => {
  const info = props.transactionInfo;
  if (!info) return "$0";

  if (isPaymentSchedule(info)) {
    return `$${info.minimumPaymentAmount}`;
  }

  if (isTransaction(info) && info.amount != null) {
    return currencyFormat(info.amount);
  }

  return "$0";
});

const setOriginalDebitInfo = () => {
  if (props.transactionInfo && isTransaction(props.transactionInfo)) {
    emit("viewRefundOriginalDebit", props.transactionInfo.originalDebitId);
  }
};

const onClose = () => {
  emit("closeDetails");
};

const handleEventForTransactionDetailsView = () => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.TransactionDetailsView,
    "CL_Transactions",
    "TransactionDetailsScreenView",
    {
      transactionType: props.transactionInfo?.type,
      hasDebitId:
        props.transactionInfo && isTransaction(props.transactionInfo)
          ? !!props.transactionInfo.debitId
          : false,
    },
  );
};

const handleEventForTransactionFailure = () => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.TransactionReportValidationFailed,
    "CL_Transactions",
    "TransactionReportValidationFailed",
    {
      hasTransactionInfo: !!props.transactionInfo,
      isValidTransaction: props.transactionInfo
        ? isTransaction(props.transactionInfo)
        : false,
      hasDebitId:
        props.transactionInfo && isTransaction(props.transactionInfo)
          ? !!props.transactionInfo.debitId
          : false,
    },
  );
};

const handleReportTransaction = () => {
  if (!reportTransactionBtnIsActive.value) return;
  reportTransactionBtnIsActive.value = false;

  if (transactionReportBtn.transactionBtn.isGreyOut) {
    showPopUp.value = true;
    reportTransactionBtnIsActive.value = true;
    return;
  }

  if (!props.transactionInfo || !isTransaction(props.transactionInfo)) {
    reportTransactionBtnIsActive.value = true;
    console.log("Cannot report transaction - invalid transaction info");
    return;
  }

  if (!props.transactionInfo.debitId) {
    reportTransactionBtnIsActive.value = true;
    console.error("Cannot report transaction - missing debitId");
    return;
  }

  logAnalyticsEvent(
    AnalyticEvents.CreditLine.TransactionReportButtonClick,
    "CL_Transactions",
    "TransactionReportAction",
    {
      debitId: props.transactionInfo.debitId,
      transactionType: props.transactionInfo.type,
    },
  );

  const debitIdParam = String(props.transactionInfo.debitId);
  console.log(
    "Navigating to report transaction page with debitId:",
    debitIdParam,
  );
  reportTransactionBtnIsActive.value = true;
  router.push({
    name: "CreditLineReportTransaction",
    params: {
      debitId: debitIdParam,
    },
  });
};

const handleServiceNavigation = () => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.TransactionDetailsAddOnExternalNavigation,
    "CL_Transactions",
    "TransactionDetailsAddOnExternalNavigation",
    {
      navigation: EXTERNAL_LINKS.MI_GUROS,
      transactionType: props.transactionInfo.type,
    },
  );
  window.open(EXTERNAL_LINKS.MI_GUROS, "_system");
};

// watchers
watch(
  [isLoad, finishLoadSettings],
  ([isLoadNewValue], [finishLoadSettingsNewValue]) => {
    if (isLoadNewValue && finishLoadSettingsNewValue) {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.TransactionReportButtonVisibilityCheck,
        "CL_Transactions",
        "TransactionReportButtonVisibility",
        {
          canReport: canReportTransaction.value,
          isFeatureEnabled: isReportingTransactionsEnabled.value,
          buttonVisible:
            canReportTransaction.value && isReportingTransactionsEnabled.value,
          hasExistingReport: !!transactionReport.value,
        },
      );
    }
  },
  { immediate: true },
);

watchEffect(() => {
  if (isPossibleToReportTransaction.value) {
    checkCanReport();
  } else {
    handleEventForTransactionFailure();
  }
});

onMounted(async () => {
  safeAndroidCall("hideNav");
  await initializeReportingSettings();
  handleEventForTransactionDetailsView();
});

onUnmounted(() => {
  safeAndroidCall("showNav");
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global";

#close-btn {
  margin-right: 0 !important;
  margin-left: 40% !important;
  background: transparent;
  box-shadow: none;
  border: none;
}

#amount-section i {
  color: #828282;
}

#explainer-container * {
  color: black;
  font-weight: normal;
}

#details-link {
  color: $pj-color-green;
  cursor: pointer;
}

.gray-out-report-transaction-btn {
  color: #8b8b8b !important;
}

#screenTitleCustom {
  font-size: 1rem;
  margin-top: 0.25rem;
  text-align: left;
}

.col-9 > :first-child {
  margin-left: 0;
}

.explainer-row * {
  color: black;
  font-weight: normal;
}

.service-info-btn,
.service-info-btn:focus,
.service-info-btn:hover,
.service-info-btn:active {
  color: $pj-color-green-spinner-light-content;
}
</style>
